<template>
    <div>
        <b-alert dismissible fade :show="notEmptyErrors.length > 0" variant="danger" role="alert">
            <span v-for="(error, index) in notEmptyErrors" :key="index"> {{ $t(error) }} <br/></span>
        </b-alert>
        <div class="row">
            <div class="fixed-top mx-auto mt-5 col-0 col-sm-6 col-md-3">
                <b-alert :show="loading" variant="info"  role="status">{{$t('global.loading')}}...</b-alert>
                <b-alert dismissible :show="created ? dismissCountDown : false" variant="success" role="status" @dismiss-count-down="countDownChanged"> {{$t('user.alert.created')}}</b-alert>
                <b-alert dismissible :show="updated ? dismissCountDown : false" variant="success" role="status"  @dismiss-count-down="countDownChanged">{{$t('user.alert.updated')}}</b-alert>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            dismissCountDown: 3
        }
    },
    watch: {
        created: function() {
            this.dismissCountDown = 3;
        },
        updated: function() {
            this.dismissCountDown = 3;
        }
    },
    props: {
        loading: {
            required: true
        },
        errors:{
            default: () => [],
            type: Array
        },
        created: {
            type: Object
        },
        updated: {
            type: Object
        },
    },
    methods: {
        countDownChanged(dismissCountDown){
            this.dismissCountDown = dismissCountDown;
        }
    },
    computed: {
      notEmptyErrors: function() {
          return this.errors.filter(function (error) {return error});
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app/Messages.vue